import { dialog } from '../../../lib/bootbox'

import { FeedbotThunk } from '../../../store/types'
import { isUnsavedSelector } from '../../../store/socketServer'
import { alertHavingUnsavedChanges } from '../utils/bootbox'
import { endpointHelpers } from '../endpointHelpers'
import { switchBot } from '../../../lib/navigation'
import { environmentGroupForCurrentBotSelector } from '../selectors/environmentGroupForCurrentBotSelector'
import { EnvironmentGroupDescriptor } from '@features/serverBots/types'

export const replaceDevWithProduction = (): FeedbotThunk => async (dispatch, getState) => {
  if (isUnsavedSelector(getState())) {
    return alertHavingUnsavedChanges()
  }

  const { prodName, testName, testId } = environmentGroupForCurrentBotSelector(getState())

  const isConfirmed = await confirmReplacingTestWithProduction({ prodName, testName })
  if (!isConfirmed) {
    return
  }

  await dispatch(endpointHelpers.moveProdToTest.initiate()).unwrap()

  if (testId) {
    switchBot(testId)
  }
}

export const confirmReplacingTestWithProduction = ({
  testName,
  prodName
}: Pick<EnvironmentGroupDescriptor, 'prodName' | 'testName'>) => {
  return new Promise((res, rej) => {
    dialog({
      title: `Replace ${testName} with ${prodName}?`,
      message: `Do you really want to push the current ${prodName} version to the ${testName} environment?`,
      size: 'medium',
      closeButton: false,
      onEscape: () => res(false),
      callback: () => res(false),
      buttons: {
        close: { label: 'Cancel', callback: () => res(false), className: 'btn-secondary' },
        ok: { label: 'Replace', callback: () => res(true), className: 'btn-positive' }
      }
    })
  })
}
